<div class="page-top">
  <nav class="navbar navbar-light navbar-expand-lg fixed-top" id="mainNav" style="background: #282d32;">
    <a class="navbar-brand" href="#">Pibeam Electric</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="nav navbar-nav ml-auto">
        <li class="nav-item text-light"><a class="nav-link js-scroll-trigger text-light" href="#about">About</a></li>
        <li class="nav-item text-light"><a class="nav-link js-scroll-trigger text-light" href="#services">Features</a>
        </li>
        <li class="nav-item text-light"><a class="nav-link js-scroll-trigger text-light" href="#contact">Contact</a>
        </li>
      </ul>
    </div>
  </nav>


  <header class="masthead text-center text-white d-flex" style="background: #282d32;">
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <h1 class="text-uppercase">
            <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
              <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="bounce animated electric-cyc" src="assets/images/new/100-1.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
                <div class="carousel-item">
                  <img class="bounce animated electric-cyc" src="assets/images/new/200.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
                <div class="carousel-item">
                  <img class="bounce animated electric-cyc" src="assets/images/new/300.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
                <div class="carousel-item">
                  <img class="bounce animated electric-cyc" src="assets/images/new/400.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
                <div class="carousel-item">
                  <img class="bounce animated electric-cyc" src="assets/images/new/500.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
                <div class="carousel-item">
                  <img class="bounce animated electric-cyc" src="assets/images/new/600.png"
                    style="margin-top: 30px;font-size: 59px;box-shadow: inset 0px 0px;">
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

          </h1>
          <hr style="border-color: #FDC701;">
        </div>
      </div>
      <div class="col-lg-8 mx-auto">
        <p class="text-faded mb-4" style="font-family: 'Open Sans', sans-serif;font-size: 24px;
           color: var(--light);font-weight: normal;letter-spacing: 1px;">
          <strong>PiMo - India's First Urban Utility EV&nbsp;UNLOCK &amp; GLIDE</strong><br>
        </p><a class="btn btn-xl js-scroll-trigger bounce animated" style="background-color: #FDC701; color: #282d32"
          role="button" href="https://pibeam-pay.netlify.app/book" target="_blank">
          ORDER NOW</a>
      </div>
    </div>
  </header>
  <section id="about" style="background-color: #FDC701">
    <div class="container">
      <div class="row">
        <div class="col offset-lg-8 mx-auto text-center" style="color: #212529">
          <h2 class="section-heading" style="color: #212529">We've got what you need!</h2>
          <hr class="light my-4" style="border-color: #212529">

          <p class="pt-3" style="font-size: 20px; color: #212529">PRE-BOOK @ Rs 2000</p>

          <p class="pt-4" style="font-size: 16px; color: #212529">For Introductory Offer Price of Rs 30000</p>

          <div class="row">
            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529">Get accessories worth Rs. 3142</span>
            </div>

            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529"> Choose your color</span>
            </div>

            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529"> Get your name engraved</span>
            </div>
          </div>

          <div class="row pt-2">
            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529"> Warranty for two year</span>
            </div>

            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529"> Free Shipping</span>
            </div>

            <div class="col">
              <i class="fa fa-check text-dark" aria-hidden="true"></i>
              <span style="font-size: 16px; color: #212529"> No driving license required</span>
            </div>
          </div>


          <div class="row pt-5 text-center justify-content-center align-content-center">
            <div class="col">
              <img src="../assets/images/certified2.png" style="width: 230px">
            </div>

            <div class="col">
              <img src="../assets/images/makeindia1.png" style="width: 300px">
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <section id="services" style="background: #282d32">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading" style="border-color: rgb(249,249,249);color: rgb(255,255,255);">Product
            Features</h2>
          <hr class="my-4" style="border-color: var(--light);">
        </div>
      </div>
    </div>
    <div class="container" style="text-align: center;">
      <div class="row" style="margin-top: 28px;">
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mx-auto service-box mt-5"><img src="assets/img/range.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: var(--white);font-size: 20px;font-family: 'Open Sans', sans-serif;">
              <strong>50
                Km </strong><strong>Range</strong>
            </h3>
            <h3 class="mb-3"
              style="color: rgb(149,150,152);font-size: 18px;margin-top: -3px;font-family: 'Open Sans', sans-serif;">
              <em>Takes you places</em><br>
            </h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mx-auto service-box mt-5"><img src="assets/img/speed.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>25
                Km/hr </strong><strong>Speed</strong></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>For a safe
                ride</em><br>
            </h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center" style="line-height: 24px;">
          <div class="mx-auto service-box mt-5" style="line-height: 24px;"><img src="assets/img/charging.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>2
                Hrs </strong><strong>Charging time</strong><br></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>Saves your
                time</em><br>
            </h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center" style="line-height: 24px;">
          <div class="mx-auto service-box mt-5" style="line-height: 24px;"><img src="assets/img/battery.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>600 Wh Li-Ion
                Battery</strong></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>Takes you back
                home</em><br></h3>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 28px;">
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mx-auto service-box mt-5"><img src="assets/img/suspension.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: var(--white);font-size: 20px;font-family: 'Open Sans', sans-serif;">
              <strong>Dual
                Telescopic Suspension</strong>
            </h3>
            <h3 class="mb-3"
              style="color: rgb(149,150,152);font-size: 18px;margin-top: -3px;font-family: 'Open Sans', sans-serif;">
              <em>Ensures smooth ride</em><br>
            </h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mx-auto service-box mt-5"><img src="assets/img/frame.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>Sturdy Frame
                with Swing Arm</strong></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>Built for all
                roads</em><br></h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center" style="line-height: 24px;">
          <div class="mx-auto service-box mt-5" style="line-height: 24px;"><img src="assets/img/brake.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>Powerful Dual
                Disc Brakes</strong></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>Stops where you want
                to</em><br></h3>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 text-center" style="line-height: 24px;">
          <div class="mx-auto service-box mt-5" style="line-height: 24px;"><img src="assets/img/motor.png"
              style="width: 34%;margin-bottom: 25px;margin-top: -28px;">
            <h3 class="mb-3" style="color: rgb(255,255,255);line-height: 24px;font-size: 20px;"><strong>250 W
                BLDC </strong><br><strong>Motor</strong></h3>
            <h3 class="mb-3" style="color: rgb(149,150,152);line-height: 24px;font-size: 18px;"><em>Electrify your
                journey</em><br></h3>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--<section id="pre-order" style="background: whitesmoke">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading" style="border-color: rgb(249,249,249);color: #000">Pre-Order
            Now!</h2>
          <hr class="my-4" style="border-color: #000">
        </div>

        <form class="w-50 mt-5">

          <div class="mb-3">
            <label for="name" class="form-label text-dark">Name</label>
            <input type="text" class="form-control" id="name" required>
          </div>

          <div class="mb-3">
            <label for="phone" class="form-label text-dark">Phone</label>
            <input type="number" class="form-control" id="phone" required>
          </div>

          <div class="mb-3">
            <label for="email" class="form-label text-dark">Email address</label>
            <input type="email" class="form-control" id="email" required>
          </div>

          <div class="mb-3">
            <label for="billingAddress" class="form-label text-dark">Billing address</label>
            <input type="text" class="form-control" id="billingAddress" required>
          </div>

          <div class="mb-3">
            <label for="deliveryAddress" class="form-label text-dark">Delivery address</label>
            <input type="text" class="form-control" id="deliveryAddress" required>
          </div>

          <div class="mb-3">
            <label for="nameEngraving" class="form-label text-dark">Name engraving</label>
            <input type="text" class="form-control" id="nameEngraving" required>
          </div>

          <div class="mb-3">
            <label for="couponCode" class="form-label text-dark">Coupon Code (FIRST100)</label>
            <input type="text" class="form-control" id="couponCode" required>
          </div>

          <div class="mb-3 pt-3">
            <label class="form-label text-dark">Pick Product Theme</label>
            <br>
            <div class="mt-1">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="red" name="rd" class="custom-control-input" value="rgb(255, 83, 73)">
                <label class="custom-control-label red" for="red">Red</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="blue" name="rd" class="custom-control-input" value="rgb(1, 191, 255)">
                <label class="custom-control-label blue" for="blue">Blue</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="green" name="rd" class="custom-control-input" value="rgb(0, 255, 204)">
                <label class="custom-control-label green" for="green">Green</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="white" name="rd" class="custom-control-input" value="rgb(255, 255, 255)">
                <label class="custom-control-label white" for="white">White</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="black" name="rd" class="custom-control-input" value="rgb(0, 0, 0)">
                <label class="custom-control-label black" for="black">Black</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="grey" name="rd" class="custom-control-input" value="rgb(104, 110, 113)">
                <label class="custom-control-label grey" for="grey">Grey</label>
              </div>
            </div>

          </div>


          <div class="mb-3 pt-3">
            <label class="form-label mr-4" for="mudguardCheck">
              Mudguard
            </label>
            <input class="form-check-input mr-4" type="checkbox" value="" id="mudguardCheck" checked>
          </div>


          <div class="mb-3">
            <label class="form-label mr-4" for="headLampCheck">
              Head Lamp
            </label>
            <input class="form-check-input" type="checkbox" value="" id="headLampCheck" checked>
          </div>


          <button type="submit" class="btn btn-primary border mt-4">Submit</button>

        </form>
      </div>
    </div>
  </section>-->

  <section id="contact" class="text-center">
    <div class="container-fluid mb-5">
      <div class="row">
        <div class="col-lg-8 mx-auto text-center">
          <h2 class="section-heading" style="font-family: 'Open Sans', sans-serif;">Reach Us At</h2>
          <hr class="my-4">

          <div class="row mt-5">
            <div class="col-sm ml-3 mr-3">
              <h5 class="text-dark font-weight-bold">
                Head Office
              </h5>
              <p>
                Pi Beam Labs Pvt Ltd <br>
                03, A2, Third Floor, IIT Incubation cell, <br>
                Kangam Road, Taramani, <br>
                Chennai-600113
              </p>
            </div>


            <div class="col-sm ml-3 mr-3">
              <h5 class="text-dark font-weight-bold">
                Manufacturing Facility
              </h5>
              <p>
                Pi Beam Labs Pvt Ltd <br>
                75, Ground Floor, <br>
                Electronics Estate, <br>
                Perungudi, Chennai - 600096
              </p>
            </div>


            <div class="col-sm ml-3 mr-3">
              <h5 class="text-dark font-weight-bold">
                Research Center
              </h5>
              <p>
                TrEST Research Park ,TC- 4/2322 <br>
                GEM building, (Opp) CET, Sreekaryam <br>
                Thiruvananthapuram <br>
                Kerala - 695016 <br>
              </p>
            </div>
          </div>

        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-4 ml-auto text-center"><i class="fa fa-phone fa-3x mb-3 sr-contact" data-aos="zoom-in"
            data-aos-duration="300" data-aos-once="true"></i>
          <p style="font-family: 'Open Sans', sans-serif;">9600019730&nbsp; |&nbsp; 7418449556<br></p>
        </div>
        <div class="col-lg-4 mr-auto text-center"><i class="fa fa-envelope-o fa-3x mb-3 sr-contact" data-aos="zoom-in"
            data-aos-duration="300" data-aos-delay="300" data-aos-once="true"></i>
          <p><a href="mailto:your-email@your-domain.com"
              style="font-family: 'Open Sans', sans-serif; color: #212529">sales@pibeam.com<br></a></p>
        </div>
      </div>
    </div>

    <span class="pt-5" style="font-size: 14px">
      Design and developed by <a href="http://www.fametechnologies.in/">Fametronix Technologies PVT Ltd</a>
    </span>

  </section>
</div>

<router-outlet></router-outlet>